import React, { useState } from 'react';
import SteppedNumberInput from '../../../Reusable/NumberInputs/SteppedNumberInput';
import { EditTextPill } from '../HeaderCommon.js';

function LightEntryHeader (props) {

  const deleteLight = (e) => {
    e.stopPropagation();
    Inventum.lights.delete(props.light.id);
    props.getLights();
  }

  const cloneLight = (e) => {
    e.stopPropagation();
    Inventum.lights.clone(props.light.id);
    props.getLights();
  }
 
  const transformLight = (e) => {
    e.stopPropagation();
    Inventum.lights.setActive(props.light.id);
    props.getLights();
  }

  const handleNameChange = (text) => {
    Inventum.lights.setName(props.light.id, text);
    props.getLights();
  }
	// style={{color: props.light.active ? "#0F0" : "#FFF"}}
  return (
    <div className='LabelHeader' onClick={props.toggleOpen}>
      <span className='PanelOpenStatus'>{props.isOpen ? '▾' : '▸'}</span>
      <span className='LabelHeaderBtn delete' title='Delete Light' onClick={deleteLight}><i className="material-icons notranslate">clear</i></span>
      <span className='LabelHeaderBtn' title='Clone Light' onClick={cloneLight}><i className='material-icons notranslate'>copy_all</i></span>
      <span className={'LabelHeaderBtn' + (props.light.active ? ' active' : '')} title='Move Light' onClick={transformLight}><i className="material-icons notranslate">open_with</i></span>
			<EditTextPill setText={(text) => {handleNameChange(text)}} value={props.light.name} label={props.light.name} />
    </div>
  )
}

function LightEntryDrawer (props) {
  if (props.light.type === 'HemisphereLight') {
    return (
      <div className="LightDrawer">
        <div className="LightDrawerSection">
          <h4 className="LightDrawerSectionTitle">Ambient Light Settings</h4>
          <SpinnerValue name='Intensity' value={props.light.intensity} min={0} step={0.1} handleUpdate={(value) => { Inventum.lights.setIntensity(props.light.id, Number(value)) }} />
        </div>
      </div>
    )
  } else if (props.light.type === 'DirectionalLight') {
    return (
      <div className="LightDrawer">
        <div className="LightDrawerSection">
          <h4 className="LightDrawerSectionTitle">Light Settings</h4>
          <SpinnerValue name='Intensity' value={props.light.intensity} min={0} step={0.1} handleUpdate={(value) => { Inventum.lights.setIntensity(props.light.id, Number(value)) }} />
        </div>
        <div className="LightDrawerSection">
          <h4 className="LightDrawerSectionTitle">Shadow Settings</h4>
          <CheckboxValue name='Enable Shadow' value={props.light.castShadow} handleUpdate={(value) => { Inventum.lights.toggleShadow(props.light.id) }} />
          <SpinnerValue name='Shadow Size' value={props.light.cameraSize} min={1} step={10} handleUpdate={(value) => { Inventum.lights.setCameraSize(props.light.id, Number(value)) }} />
          <SpinnerValue name='Shadow Far' value={props.light.cameraFar} min={1} step={10} handleUpdate={(value) => { Inventum.lights.setFar(props.light.id, Number(value)) }} />
          <SpinnerValue name='Shadow Bias' value={props.light.bias} min={-0.001} max={0.001} step={0.0001} handleUpdate={(value) => { Inventum.lights.setBias(props.light.id, Number(value)) }} />
        </div>
      </div>
    )
  }
  return null;
}

function SpinnerValue (props) {
  const [value, setValue] = useState(props.value);
  const onChange = (e) => {
    setValue(e.target.value);
    if (typeof (props.handleUpdate) === 'function') {
      props.handleUpdate(e.target.value);
    }
  }

  return (
    <div className="LightInputGroup">
      <label className="LightInputLabel" title={props.name}>{props.name}</label>
      <SteppedNumberInput className="LightInput" min={props.min} max={props.max} step={props.step} value={value} onChange={onChange} />
    </div>
  )
}

function CheckboxValue (props) {
  const [checked, setValue] = useState(props.value);
  const onChange = (e) => {
    setValue(e.target.checked);
    if (typeof (props.handleUpdate) === 'function') {
      props.handleUpdate(e.target.checked);
    }
  }

  return (
    <div className="LightInputGroup">
      <label className="LightInputLabel" title={props.name}>{props.name}</label>
      <label className="LightCheckboxWrapper">
        <input className="LightCheckbox" type='checkbox' checked={checked} onChange={onChange} />
        <span className="LightCheckboxCustom">
          <i className="material-icons notranslate">{checked ? 'check_box' : 'check_box_outline_blank'}</i>
        </span>
      </label>
    </div>
  )
}

class LightEntry extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render () {
    return (
      <div>
        <LightEntryHeader getLights={this.props.getLights} toggleOpen={() => { this.props.getLights(); this.setState({ isOpen: !this.state.isOpen }); }} isOpen={this.state.isOpen} light={this.props.light} />
        { this.state.isOpen ? <LightEntryDrawer getLights={this.props.getLights} light={this.props.light} /> : null }
      </div>
    )
  }
}

function LightsCollection (props) {
  const createDirectional = (e) => {
    Inventum.lights.create({
      type: 'DirectionalLight',
      intensity: 1,
      position:{ x: 20, y: 20,z: 20 },
      target:{ x: 0,y: 0, z: 0 },
      color:'#FFFFFF'
    });
    props.getLights();
  };

  const createHemi = (e) => {
    Inventum.lights.createAmbient();
    props.getLights();
  };

  return (
    <div className='LabelDrawCollection'>
      <div className="LightCreateButtonGroup">
        <button onClick={createDirectional} className='LightCreateButton' title='Create Directional Light'>
          <i className="material-icons notranslate">add</i>
          <span>Directional Light</span>
        </button>
        <button onClick={createHemi} className='LightCreateButton' title='Create Ambient Light'>
          <i className="material-icons notranslate">add</i>
          <span>Ambient Light</span>
        </button>
      </div>
      <div>
        {props.lights.map((light, index) => <LightEntry getLights={props.getLights} key={index} light={{...light}} />)}
      </div>
    </div>
  )
}

class InventumLightsEditor extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      lights:[]
    };
    this.getLights = this.getLights.bind(this);
  }

  componentDidMount () {
    this.getLights();
  }

  getLights () {
    const lights = Inventum.lights.getAll();
    this.setState({ lights: lights });
  }


  render () {
		const handleHelp = (e) => {
			e.stopPropagation();
			window.open('https://docs.inventum3d.com/lights/', '_blank');
		};

    return (
      <div className='LabelsPanel'>
				<div className="EditorTabHeader">
					<div className="EditorTabTitle">
						<i className="material-icons notranslate">tungsten</i>
						<span>Lights</span>
					</div>
					<button className="EditorTabHelpButton" title='Opens the Inventum Docs' onClick={handleHelp}>
						<i className="material-icons notranslate">help</i>
					</button>
        </div>
        <LightsCollection getLights={this.getLights} lights={this.state.lights} />
      </div>
    )
  }
}

export default InventumLightsEditor
